import React from 'react';

import { useApplicationContext } from '@common/react/components/Core/Application/Application';
import { WithId } from '@common/typescript/objects/WithId';
import { getDefaultOptions } from '@common/react/components/UI/Transmutation/defaultOptions';

interface TransmutationBackKeyboardProps<TResponse extends WithId = WithId, TRequest extends WithId = TResponse> {
	/* eslint-disable */
	requestType?: string;
	requestProps?: TRequest;
	onSuccess?: (response: TResponse) => void;
	onError?: (err: string) => void;
	/* eslint-disable */
}

const TransmutationBackKeyboard: <TResponse extends WithId = WithId, TRequest extends WithId = TResponse>(
	props: TransmutationBackKeyboardProps<TResponse, TRequest>,
) => React.ReactElement = <TResponse extends WithId = WithId, TRequest extends WithId = TResponse>(
	props: TransmutationBackKeyboardProps<TResponse, TRequest>,
) => {
	const {
		requestType,
		requestProps,
		onSuccess,
		onError,
	} = {
		...getDefaultOptions<TRequest>(),
		...props,
	};

	const {
		getTransmutationFlag,
		request,
	} = useApplicationContext();
	const transmuted = getTransmutationFlag();
	React.useEffect(() => {
		if (transmuted) {
			const keydown = (e: KeyboardEvent) => {
				if (e.code === 'KeyB' && (e.ctrlKey || e.metaKey)) {
					e.preventDefault();
					request<TResponse, TRequest>(requestType, requestProps)
						.then(onSuccess)
						.catch(onError);
				}
			};
			document.addEventListener('keydown', keydown);
			return () => {
				document.removeEventListener('keydown', keydown);
			};
		}
	}, [transmuted]);
	return <></>;
};

export default TransmutationBackKeyboard;
